export { default as careersLocaleEn } from './localeEn';
export { default as careersLocaleEs } from './localeEs';
export { default as careersLocalePt } from './localePt';
